import Component from 'flarum/Component';
import { render } from 'slimdown-js';

export default class WelcomeHero extends Component {
  view() {
    return (
      <header className="Hero WelcomeHero">
        <div className="container">
          <div className="containerNarrow">
            <div className="Hero-subtitle">
              {
                m.trust( render(app.forum.attribute('welcomeMessage')) )
              }
            </div>
          </div>
        </div>
      </header>
    );
  }
}
